// extracted by mini-css-extract-plugin
module.exports = {"photo":"WSVirtualAssistant_photo__1sHea","card":"WSVirtualAssistant_card__1_qqI","msg":"WSVirtualAssistant_msg__14_z3"};